import React from "react";
import { X } from "lucide-react";
import {
  expiryStatusoptions,
  scheduleoptions,
  stockInOutOptions,
} from "../../helper-components/data";
import FilterRadioButtons from "../../forms/filter-radio-buttons";

// Plain panel - the page decides where it sits, so it never ends up clipped
// inside a scrolling container.
const StockDetailsFilter = ({
  setFilterData,
  filterData,
  initFilter = {},
  onClose = () => {},
}) => {
  const handleChange = (e) => {
    setFilterData({
      ...filterData,
      [e.target.name]: e.target.value,
    });
  };

  const hasActiveFilters =
    filterData?.stock_status || filterData?.expiry_status || filterData?.rx_drugs;

  return (
    <div
      style={{
        boxShadow: `0 12px 32px -8px var(--popover-shadow-color), 0 2px 6px -2px var(--popover-shadow-color)`,
      }}
      className="w-[min(20rem,calc(100vw-2rem))] max-h-[75vh] flex flex-col border border-[var(--popover-border-color)] bg-[var(--popover-bg-color)] rounded-xl"
    >
      <div className="flex items-start justify-between gap-3 px-4 pt-4 pb-2">
        <div>
          <span className="block text-[length:--popover-h1-fs] font-[var(--popover-heading-font-weight)] text-[var(--popover-heading-fg-color)]">
            Filters
          </span>
          <p className="text-[length:--popover-desc-font-size] font-[var(--popover-desc-font-weight)] text-[var(--popover-desc-fg-color)]">
            Narrow down the product list
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close filters"
          className="p-1 rounded-md text-[var(--popover-desc-fg-color)] hover:bg-[var(--popover-border-color)]"
        >
          <X size={16} />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto">
        <FilterRadioButtons
          name="stock_status"
          label={"Status"}
          options={stockInOutOptions}
          handleChange={handleChange}
          value={filterData?.stock_status}
        />
        <hr className="border-0 border-t border-[var(--popover-border-color)] mx-3" />
        <FilterRadioButtons
          name="expiry_status"
          label={"Expiry Status"}
          options={expiryStatusoptions}
          handleChange={handleChange}
          value={filterData?.expiry_status}
        />
        <hr className="border-0 border-t border-[var(--popover-border-color)] mx-3" />
        <FilterRadioButtons
          name="rx_drugs"
          label={"Rx Drugs"}
          options={scheduleoptions}
          handleChange={handleChange}
          value={filterData?.rx_drugs}
        />
      </div>

      <div className="flex items-center justify-between gap-2 px-4 py-3 border-t border-[var(--popover-border-color)]">
        <button
          type="button"
          disabled={!hasActiveFilters}
          onClick={() => {
            // Keep whatever is typed in the search box
            setFilterData({ ...initFilter, search: filterData?.search || "" });
          }}
          className="text-sm font-medium text-[var(--primary)] disabled:text-[var(--popover-desc-fg-color)] disabled:cursor-not-allowed"
        >
          Clear all
        </button>
        <button
          type="button"
          onClick={onClose}
          className="h-[36px] px-4 rounded-[8px] text-sm font-medium bg-[var(--primary-button-bg-color)] text-[var(--primary-button-fg-color)] hover:bg-[var(--primary-button-hover-color)]"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default StockDetailsFilter;
